import moment from 'moment';
import { createContext, useContext, useEffect, useState } from 'react';
import slugify from 'react-slugify';
import { getDashboardContext, saveDashboardContext } from '../utils/dashboardHelper';
const DashboardContext = createContext(null);

const initial = {
  options: {
    offset: 0,
    rows: 50,
    page: 0
  },
  filters: {
    query: '',
    stateList: [],
    typeList: [],
    roomList: [],
    propertyList: []
  },
  dateRange: undefined,
  sortOption: {
    sortLabel: 'Date de début',
    sortField: 'start_dt',
    sortOrder: 1,
    sortType: 'date'
  }
};

export const DashboardContextProvider = ({ children }) => {
  const [dashboardContext, setDashboardContext] = useState(
    getDashboardContext() ? { ...getDashboardContext(), dateRange: undefined } : initial
  );

  useEffect(() => {
    if (dashboardContext) {
      saveDashboardContext(dashboardContext);
    }
  }, [dashboardContext]);

  const setDashboardFilterMultiple = (key, value) => {
    setDashboardContext({
      ...dashboardContext,
      filters: {
        ...dashboardContext.filters,
        [key]: value
      }
    });
  };

  const setDashboardDateRange = (dates) => {
    setDashboardContext({
      ...dashboardContext,
      dateRange: dates
    });
  };

  const setDashboardSort = (sortOption) => {
    setDashboardContext({
      ...dashboardContext,
      sortOption
    });
  };

  const setDashboardOptions = (options) => {
    setDashboardContext({
      ...dashboardContext,
      options
    });
  };

  const filteringIsActive = () => {
    return dashboardContext.filters !== initial.filters;
  };

  const buildQueryParams = () => {
    let queryParams = '';
    if (dashboardContext.filters.query) {
      queryParams += `&query=${slugify(dashboardContext.filters.query)}`;
    }
    if (dashboardContext.filters.stateList.length) {
      queryParams += `&states=${dashboardContext.filters.stateList.join(',')}`;
    }
    if (dashboardContext.filters.typeList.length) {
      queryParams += `&types=${dashboardContext.filters.typeList.join(',')}`;
    }
    if (dashboardContext.filters.roomList.length) {
      queryParams += `&rooms=${dashboardContext.filters.roomList.map((r) => r.id).join(',')}`;
    }
    if (dashboardContext.filters.propertyList.length) {
      queryParams += `&properties=${dashboardContext.filters.propertyList.map((p) => p.id).join(',')}`;
    }
    if (
      dashboardContext.dateRange &&
      dashboardContext.dateRange[0] &&
      dashboardContext.dateRange[1]
    ) {
      queryParams += `&start_dt=${moment(dashboardContext.dateRange[0]).format('YYYY-MM-DD')}&end_dt=${moment(dashboardContext.dateRange[1]).format('YYYY-MM-DD')}`;
    }
    return queryParams;
  };

  return (
    <DashboardContext.Provider
      value={{
        dashboardContext,
        setDashboardFilterMultiple,
        setDashboardDateRange,
        setDashboardSort,
        setDashboardOptions,
        filteringIsActive,
        buildQueryParams
      }}>
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboardContext = () => {
  return useContext(DashboardContext);
};
